// Object contains line for each section. If no path, then that section doesn'need a line...
export const lines = [
  {
    id: 0,
    description: "landing section - short path starts...",
    path: "M671.103 904.865C740.697 876.371 1076.76 870.024 1162.13 918.286C1247.5 966.548 1183.36 1061.54 1044.03 1119.89",
    mobile_path:
      "M101.105 599.499C222.24 560.105 340.422 593.589 315.8 676.316C291.179 759.043 185.801 767.906 66.6357 872.299",
  },
  {
    id: 1,
    description: "draws a heart",
    path: "M1056 -2.49283C877.035 81.8497 422.183 93.5705 262.913 303.243C103.643 512.915 154.045 863.712 363.716 996.774C573.388 1129.83 957.745 994.258 957.745 880.291C957.745 782.666 835.832 854.448 860.551 854.448C885.271 854.448 748.624 786.745 764.939 893.816C793.483 1081.14 1557.31 1084.7 1714.98 1055.62",
    mobile_path:
      "M92.6403 -1.28271C-86.5368 130.114 -93.544 480.468 -36.0859 623.412C-7.84392 693.673 50.3145 814.91 124.449 832.047C201.52 849.863 272.336 806.803 252.225 759.708C232.281 722.186 191.041 767.482 201.52 767.482C220.788 767.482 158.928 723.876 153.857 767.482C144.055 832.723 236.003 857.539 397.206 794.689",
  },
  {
    id: 2,
    description: "about us - right to left, draws a little loop",
    path: "M1735.75 283.87C1362.16 345.766 1453.34 931.743 904.58 991.247C354.152 1050.93 396.152 818.824 504.47 834.298C612.787 849.771 460.258 1141.56 -12.7998 1050.93",
    mobile_path:
      "M421.325 492.31C401.429 687.547 100.247 748.499 141.527 675.111C182.808 601.723 248.472 796.979 -11.4292 754.698",
  },
  {
    id: 3,
    description:
      "what we do - title, this was a half height section, left to right short line",
    path: "M-2.51514 542.343C3.30097 656.489 212.572 787.766 595.252 700.655C1103.32 585.002 1235.75 989.678 1714.58 865.684",
    mobile_path:
      "M-9.8916 529.472C65.8757 506.172 110.787 538.375 195.457 597.175C280.126 655.976 392.301 663.01 425.933 624.432",
  },
  {
    id: 4,
    description: "we do this by - begins to join in with sections below",
    path: "M-7.58105 862.813C180.916 1032.24 643.183 1014.28 768.845 970.525C1012.71 885.605 1429.12 928.051 1536.06 1117.7",
    mobile_path:
      "M-9.8916 529.472C65.8757 506.172 164.453 522.489 230.049 564.232C295.645 605.975 362.013 728.604 324.089 854.518",
  },
  {
    id: 5,
    description:
      "being refreshingly human, joins top and bottom with loop around text",
    path: "M1534.24 -2.69922C1678.48 247.55 1654.26 945.863 907.506 883.407C160.754 820.952 79.2906 250.706 679.407 212.69C1279.52 174.673 1466.89 427.211 1363.7 655.309C1260.52 883.407 1039.92 886.777 867.92 906.778C695.917 926.778 548.706 1015.32 450.859 1118.29",
    mobile_path:
      "M325.46 -1.86463C279.591 140.614 28.6608 216.369 28.6609 467.69C28.6609 719.012 312.763 733.217 357.564 521.233C402.365 309.249 287.632 220.74 164.156 239.316C40.681 257.892 -115.658 641.278 264.021 876.845",
  },
  {
    id: 6,
    description:
      "celebrating the beauty... joins top and bottom, loops around text",
    path: "M455.635 -4.17236C320.455 149.845 194.305 520.854 382.671 736.921C571.037 952.988 1277.36 1048.59 1428.49 685.603C1551.56 390.011 1262.69 33.9112 845.883 73.0587C429.076 112.206 240.963 335.686 281.697 628.032C322.431 920.379 1052.49 1117.53 1712.36 982.653",
    mobile_path:
      "M225.437 -1.03784C434.198 159.87 414.171 356.278 363.75 520.261C313.33 684.244 123.738 728.102 39.8615 569.839C-44.015 411.575 72.8464 199.985 225.437 236.699C378.028 273.413 420.765 498.706 331.276 698.336C291.444 787.192 202.778 833.55 -1.18457 779.276",
  },
];
